<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <list-selector
          v-model="message.memberships"
          :selected-source="message.memberships"
          hint="memberships"
          autofocus
          no-translate
          field-name="membership_type"
          source-type="memberships"
          return-value="id"
        />
      </v-col>
      <v-col cols="12">
        <validated-text-field
          v-model="message.subject"
          field-name="subject"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col cols="12">
        {{ $t('fields.body') }}
        <v-textarea
          v-model="message.body"
          clearable
          autofocus
          solo
          clear-icon="mdi-close-circle"
          rows="10"
          counter
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="message.show_dashboard"
          :label="$t('fields.show_dashboard')"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="message.send_notification"
          :label="$t('fields.send_notification')"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="message.send_mail"
          :label="$t('fields.send_mail')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditMessage',
    props: {
      message: Object,
    },
    data: function () {
      return {
        selected_memberships: [],
      }
    },
    computed: {
    },
    methods: {
    },
  }
</script>
